import {
    Card,
    CardBody,
    CardHeader,
    Col,
    FormGroup,
    Label,
    Row
} from "reactstrap";
import CopyInviteLink from "../../../Components/Buttons/CopyInviteLinkButton";
import { DASHBOARD_USER_ROLES } from "../../../constants";
import { useReferralLinkBuilder } from "../../../hooks/useReferralLinkBuilder";
import { useCurrentUser } from "../../../slices/auth/hooks";
import { getBaseUrl } from "../../../utils/utils";

const AccessLinksCard = () => {
    const currentUser = useCurrentUser();
    const {
        createAgentMemberLinkFromAgentCode,
    } = useReferralLinkBuilder();

    const showAgentLoginLink =
        currentUser.role === DASHBOARD_USER_ROLES.NATIONAL ||
        currentUser.role === DASHBOARD_USER_ROLES.GA ||
        currentUser.role === DASHBOARD_USER_ROLES.BROKER;



    const agentLoginLink =
        `${getBaseUrl()}/login?inviteCode=${currentUser.inviteCode}`;

    const memberLoginLink = createAgentMemberLinkFromAgentCode(
        currentUser.defaultPromoCode?.code,
    );

    return (
        <Card className="p-0 mb-4 shadow-none">
            <CardHeader className="bg-white">
                <h4 className="mb-0">Access Links</h4>
            </CardHeader>
            <CardBody>
                <Row>
                    {showAgentLoginLink && (
                        <Col md={6}>
                            <FormGroup>
                                <Label>Agent Login</Label>
                                <CopyInviteLink
                                    customCopyLink={agentLoginLink}
                                    label="Copy Agent Login Link"
                                />
                            </FormGroup>
                        </Col>
                    )}

                    <Col md={6}>
                        <FormGroup>
                            <Label>Member Login</Label>
                            <CopyInviteLink
                                customCopyLink={memberLoginLink}
                                label="Copy Member Login Link"
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default AccessLinksCard;